import React from 'react';
import { useSelector } from 'react-redux';
import { RootReducersState } from 'redux/reducers';
import { IProps } from './types';
import commonService from 'utils/commonService';

const PetInfo: React.FC<IProps> = (props) => {
  const resources = useSelector((state: RootReducersState) => state.resources);
  return (
    <div className="pet-info">
      <div className="pet-info__title">{commonService.getNameByLng(resources, 'TID_Pet_Information')}</div>
      <div className="pet-info__content">
        <div className="element__list">
          {/* 寵物姓名 */}
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Pet_Name')}</div>
              <div className="element__list-group-content">
                {
                  props.PET_NAME ? props.PET_NAME : '-'
                }
              </div>
            </div>
          </div>
          {/* 品種 */}
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Breed')}</div>
              <div className="element__list-group-content">
                {
                  props.PET_VAR_NAME ? props.PET_VAR_NAME : '-'
                }
              </div>
            </div>
          </div>
          {/* 種類 */}
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Species')}</div>
              <div className="element__list-group-content">
                {
                  props.PET_VAR_TYPE ? props.PET_VAR_TYPE : '-'
                }
              </div>
            </div>
          </div>
          {/* 性別 */}
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Sex')}</div>
              <div className="element__list-group-content">
                {
                  props.PET_SEX ? props.PET_SEX : '-'
                }
              </div>
            </div>
          </div>
          {/* 是否絕育 */}
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Neuter_Unneutered')}</div>
              <div className="element__list-group-content">
                {
                  props.PET_STERIL ? props.PET_STERIL : '-'
                }
              </div>
            </div>
          </div>
          {/* 晶片號碼 */}
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Microchip_Number')}</div>
              <div className="element__list-group-content">
                {
                  props.PET_CHIP ? props.PET_CHIP : '-'
                }
              </div>
            </div>
          </div>
          {/* 出生日期 */}
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Birth_date')}</div>
              <div className="element__list-group-content">
                {
                  props.PET_BDAY ? commonService.parseDate(props.PET_BDAY) : '-'
                }
              </div>
            </div>
          </div>
          {/* 年齡 */}
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Age')}</div>
              <div className="element__list-group-content">
                {
                  props.PET_AGE_Y ? props.PET_AGE_Y : '-'
                }
              </div>
            </div>
          </div>
          {/* 體重 */}
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Weight')}</div>
              <div className="element__list-group-content">
                {
                  props.PET_WEIGHT ? `${props.PET_WEIGHT}公斤` : '-'
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PetInfo;
